import { API_BASE_URL } from '@/environment'
import ApiService from '@/service/api.service.js'
import { customFetch } from '@/service/v3/apiV3Utils'
import type { CompanySettings, V3Response } from '@/types'
import { useSWR } from '@attensi/swr'
import { computed } from 'vue'
import type { Company } from './v1Responses'
import { wrapV1ApiService } from './wrapV1ApiService'

const fetchCurrentCompany = () => {
  return wrapV1ApiService<Company>(() => ApiService.getCurrentCompany())
}

const fetchCurrentCompanySettings = async (
  nameKey: string | undefined
): V3Response<CompanySettings> => {
  if (!nameKey) return Promise.resolve(undefined)
  const res = await customFetch(
    `${API_BASE_URL}/api/v3/admin/companies/${nameKey}/settings`,
    { method: 'GET' }
  )

  return res.json() as V3Response<CompanySettings>
}

export const useCurrentCompany = () => {
  return useSWR(['current-company'], fetchCurrentCompany)
}

export const useCurrentCompanySettings = () => {
  const { data: currentCompany } = useCurrentCompany()
  const companyNameKey = computed(() => currentCompany.value?.name_key)
  const swrKey = [companyNameKey, 'current-company-settings']

  const { data, error, mutate } = useSWR(swrKey, fetchCurrentCompanySettings)

  const companySettings = computed(() => data.value?.data.attributes)

  return {
    companySettings,
    error,
    mutate,
  }
}
